import {
  Box,
  Button,
  Checkbox,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { useEffect, useMemo, useRef, useState } from "react";
import {
  fAlertToast,
  getStatusStyle,

} from "../../Utility/Utilitys";
import {
  VNDRDISB_Approve_Update,
  VNDRDISB_Confirm_GetRow,
  VNDRDISA_Reverse,
} from "../../Server/ApiV2";
import moment from "moment";
import {
  VendorDiscontinueChangeApproveRo,
  vRdxUserInfo,
} from "../../Redux/roStore";
import { useDispatch, useSelector } from "react-redux";
import "./VendorDiscontinueChangeApprove.css";
import { DataGridPro, gridRowIdsSelector, useGridApiRef } from "@mui/x-data-grid-pro";
import { Head_Set } from "./SliceVendorDiscontinueChangeApprove";
import { confirmAlert } from "react-confirm-alert";
import CustomToolbar from "../../Component/Common/ReuseableComponent/DatagridToolbar";
import GCAutocompleteCheckboxFixSizeUid from "../VendorDiscontinueChangeRequest/GCAutocompleteCheckboxFixSizeUid";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";

const ApproveModal = ({ rejectTypeArr, handleClose, fonLoad, type }) => {
  const [detailData, setDetailData] = useState([]);
  const dispatch = useDispatch();
  const apiRef = useGridApiRef();
  const rowRef = useRef([]);

  const HeadObject = VendorDiscontinueChangeApproveRo();
  const isEditAllowed = useSelector(
    (state) => state.SliceDB.value.DBKernObj.EDIT_STOCKSETUP_VAL_IN_APP_MODE.Val
  );
  const vRdxuserLoc = useSelector(
    (state) => state.SliceDB.value.Location.LocWithRights
  );
  const transObj = useSelector(
    (state) => state.SliceVendorDiscontinueChangeApprove.value.Head
  );

  const isActionButtonDisabled = useMemo(() => {
    const status = HeadObject?.Head;
    if (type === "") {
      return (
        status?.ApproveStatus === "POST" || status?.ApproveStatus === "REJECT"
      );
    }
    if (type === "CM") {
      return status?.A_Status_CM === "POST" || status?.A_Status_CM === "REJECT";
    }
    if (type === "PM") {
      return status?.A_Status_PM === "POST" || status?.A_Status_PM === "REJECT";
    }
    return false;
  }, [type, HeadObject?.Head]);

  const shouldShowReverseButton = () => {
    const head = HeadObject?.Head;

    if (!head) return false;

    const aStatusPM = head.A_Status_PM?.toUpperCase();
    const aStatusCM = head.A_Status_CM?.toUpperCase();
    const aStatus = head.A_Status?.toUpperCase();
    const approveStatus = head.ApproveStatus?.toUpperCase();

    if (type === "") {
      return (
        aStatusPM === "REJECT" && aStatusCM === "POST" && aStatus !== "ENTER"
      );
    }

    if (type === "CM") {
      return (
        // approveStatus === "REJECT" &&
        aStatusPM === "REJECT" && aStatusCM === "POST"
      );
    }

    if (type === "PM") {
      return (
        approveStatus === "REJECT" &&
        aStatusPM === "POST" &&
        aStatusCM === "POST"
      );
    }

    return false;
  };
  const handleLoadBtn = async () => {
    if (HeadObject?.Head?.A_Transid === "") {
      fAlertToast("FAILED", "Trans ID should not be empty");
      return;
    }

    var obj = {
      B_Transid: HeadObject?.Head?.A_Transid || "",
    };

    const StockResponse = await VNDRDISB_Confirm_GetRow(obj);
    if (StockResponse?.status === 200) {
      setDetailData(StockResponse?.data?.ResultSet);
    }
  };

  const handleFieldEdit = (params, value, fieldName, parser = (v) => v) => {
    const row = rowRef.current;
    const currentRowIndex = row.findIndex(
      (r) => r.B_Srno === params.row.B_Srno
    );

    const updatedRow = {
      ...row[currentRowIndex],
      [fieldName]: parser(value),
    };

    const newRowData = [...row];
    newRowData[currentRowIndex] = updatedRow;
    setDetailData(newRowData);
  };

  const fSave = async (isApproved, name, isRejected) => {
    const vRdxUserInfoObj = vRdxUserInfo();

    var obj = {
      B_TransId: HeadObject?.Head?.A_Transid || "",
      UserCd: vRdxUserInfoObj?.UserID || "",
      isApproved: isApproved,
      isRejected: isRejected,
      LineItems: detailData,
      Type: type,
    };

    const StockResponse = await VNDRDISB_Approve_Update(obj);
    if (StockResponse?.status === 200) {
      fAlertToast("SUCCESS", `${name} Successfully`);
      dispatch(
        Head_Set({
          ...transObj,
          approveStatus: name === "Approved" ? "POST" : transObj.approveStatus,
        })
      );
      await fonLoad();
      if (isApproved || isRejected) {
        handleClose();
      }

      if (name === "Saved") await handleLoadBtn();
    } else {
      fAlertToast("FAILED", StockResponse?.data?.error || "Operation failed");
    }
  };

  const yesNoOptions = [
    { Uid: "Y", Name: "Yes" },
    { Uid: "N", Name: "No" },
  ];

  const getOldCellClass = (oldValue, newValue) =>
    oldValue !== newValue ? "cell-old" : "";
  const getNewCellClass = (oldValue, newValue) =>
    oldValue !== newValue ? "cell-new" : "";

  const columnGroupingModel = [
    {
      groupId: "Discontinued",
      children: [
        { field: "Old_DisContinued" },
        { field: "New_DisContinued" },
        { field: "B_Appr_DisContinued" },
        { field: "B_NarrationName" },
      ],
    },
  ];

  const rejectSave = async () => {
    const vRdxUserInfoObj = vRdxUserInfo();

    const items = detailData?.map((item) => {
      let {
        B_NarrationName,
        P_B_Narration,
        B_RejectDetailName,
        B_RejectDetail,
        ...rest
      } = item;
      return rest;
    });

    var obj = {
      B_TransId: HeadObject?.Head?.A_Transid || "",
      UserCd: vRdxUserInfoObj?.UserID || "",
      isApproved: false,
      isRejected: true,
      LineItems: items,
      Type: type,
    };
    const rejectRes = await VNDRDISB_Approve_Update(obj);
    if (rejectRes?.status === 200) {
      fAlertToast("SUCCESS", "Rejected Successfully");
      dispatch(
        Head_Set({
          ...transObj,
          approveStatus: "REJECT",
        })
      );
      await fonLoad();
      handleClose();
    }
  };
  const reverseSave = async () => {
    // const HeadObject = StockSetupChangeRequestRo();
    const obj = {
      A_TransId: HeadObject?.Head?.A_Transid || 0,
      UserCd: vRdxUserInfo()?.UserID,
      Type: type,
    };
    const reverseRes = await VNDRDISA_Reverse(obj);
    if (reverseRes?.status === 200) {
      const obj = {
        ...transObj,
      };
      if (type === "PM") obj.A_Status_PM = "ENTER";
      else if (type === "CM") obj.A_Status_CM = "ENTER";
      else {
        obj.approveStatus = "ENTER";
      }
      dispatch(Head_Set(obj));
      fAlertToast("SUCCESS", "Reversed Successfully");
      await fonLoad();
      handleClose();
    } else {
      fAlertToast("FAILED", "Reverse Failed");
    }
  };

     const handleExport = () => {
    apiRef.current.exportDataAsCsv({
      getRowsToExport: ({ apiRef }) => gridRowIdsSelector(apiRef),
      includeHeaders: true,
      utf8WithBom: true,
    });
    };
  
    const handlePrint = () => {
      apiRef.current.exportDataAsPrint();
    };

  useEffect(() => {
    handleLoadBtn();
  }, []);

  useEffect(() => {
    rowRef.current = detailData;
  }, [detailData]);

  return (
    <>
      {/* Header Info */}
      <Grid
        container
        spacing={{ xs: 0.5, sm: 1 }}
        sx={{
          borderRadius: "12px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
          backgroundColor: "white",
          padding: "12px",
          marginTop: "12px !important",
        }}
      >
        {[
          { label: "Trans ID", value: HeadObject?.Head?.A_Transid },
          {
            label: "Trans Date",
            value: moment(HeadObject?.Head?.A_Date).format("DD/MM/YYYY"),
          },
          { label: "Trans Loc ID", value: HeadObject?.Head?.A_Location },
          { label: "Trans Loc Name", value: HeadObject?.Head?.Loc_Name },
          { label: "Narration", value: HeadObject?.Head?.A_Narration },
          {
            label: "Status",
            value: HeadObject?.Head?.A_Status,
              renderCell: (params) => {
                const style = getStatusStyle(params.value);
                return <span style={style}>{params.value}</span>;
              },
          },
          {
            label: "CM Status",
            value: HeadObject?.Head?.A_Status_CM,
               renderCell: (params) => {
                const style = getStatusStyle(params.value);
                return <span style={style}>{params.value}</span>;
              },
          },
          {
            label: "PM Status",
            value: HeadObject?.Head?.A_Status_PM,
              renderCell: (params) => {
                const style = getStatusStyle(params.value);
                return <span style={style}>{params.value}</span>;
              },
          },
          {
            label: "Confirm Status",
            value: HeadObject?.Head?.ApproveStatus,
            renderCell: (params) => {
              const style = getStatusStyle(params.value);
              return <span style={style}>{params.value}</span>;
            },
          },
          { label: "Created By", value: HeadObject?.Head?.CreatedBy },

          {
            label: "Created Date",
            value: moment(HeadObject?.Head?.CreatedDate).format("DD/MM/YYYY"),
          },
          {
            label: "Vendor",
            value:
              HeadObject?.Head?.A_Vendor + " - " + HeadObject?.Head?.VendorName,
          },
        ].map((item, idx) => (
          <Grid item xs={12} sm={4} md={4} key={idx}>
            <Grid container alignItems="center" spacing={1} wrap="nowrap">
              <Grid item xs={5.5}>
                <Typography
                  variant="body2"
                  fontWeight="bold"
                  color="#0d73bb"
                  sx={{
                    minWidth: "120px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {item.label}
                </Typography>
              </Grid>
              <Grid item xs={6.5}>
                <Typography
                  variant="body2"
                  sx={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {item.renderCell
                    ? item.renderCell({ value: item.value })
                    : item.value}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        ))}
        <Grid item xs={12}>
          <Box
            display="flex"
            justifyContent={"flex-end"}
            gap={{xs:0.1,sm:1}}
            flexWrap={"wrap"}
          >
            <Button
              variant="contained"
              size="small"
              onClick={() => fSave(false, "Saved")}
              disabled={isActionButtonDisabled}
            >
              Save
            </Button>
            <Button
              variant="contained"
              size="small"
              onClick={() => {
                confirmAlert({
                  title: "Confirm Approve",
                  message: "Are you sure you want to approve?",
                  buttons: [
                    {
                      label: "Yes",
                      onClick: () => fSave(true, "Approved"),
                    },
                    {
                      label: "No",
                      onClick: () => {},
                    },
                  ],
                });
              }}
              disabled={isActionButtonDisabled}
            >
              Approve
            </Button>{" "}
            <Button
              variant="contained"
              color="error"
              size="small"
              onClick={() => {
                confirmAlert({
                  title: "Confirm Reject",
                  message: "Are you sure you want to reject?",
                  buttons: [
                    {
                      label: "Yes",
                      onClick: () => rejectSave(),
                    },
                    {
                      label: "No",
                      onClick: () => {},
                    },
                  ],
                });
              }}
              disabled={isActionButtonDisabled}
            >
              Reject
            </Button>
            {shouldShowReverseButton() && (
              <Button
                variant="contained"
                color="error"
                size="small"
                sx={{ textTransform: "capitalize" }}
                onClick={() => {
                  confirmAlert({
                    title: "Confirm Action",
                    message: "Are you sure you want to Reverse?",
                    buttons: [
                      {
                        label: "Yes",
                        onClick: () => {
                          reverseSave();
                        },
                      },
                      {
                        label: "No",
                        onClick: () => {},
                      },
                    ],
                  });
                }}
              >
                Reverse
              </Button>
            )}
            <Tooltip title="Export CSV">
              <IconButton color="primary" onClick={handleExport} size="small">
                <DownloadOutlinedIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Print">
              <IconButton color="primary" onClick={handlePrint} size="small">
                <PrintOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Grid>
      </Grid>
      {/* Data Grid */}
      <Box sx={{ height: { xs: "46vh", sm: "57vh" }, mt: 1 }}>
        <DataGridPro
         apiRef={apiRef}
          rows={detailData}
          columns={[
            { field: "B_Srno", headerName: "Sr No", width: 75, hide: true },
            {
              field: "B_TransId",
              headerName: "Trans ID",
              width: 80,
              hide: true,
            },
            {
              field: "B_Itemcd",
              headerName: "Item Code",
              width: 100,
              align: "center",
              headerAlign: "center",
            },
            {
              field: "ItmName",
              headerName: "Item Name",
              minWidth: 160,
              flex:1,
              // headerAlign: "center",
              renderCell: ({ value }) => (
                <Tooltip title={value}>
                  <Typography
                    variant="body2"
                    sx={{ whiteSpace: "normal", lineHeight: "1.4em" }}
                  >
                    {value}
                  </Typography>
                </Tooltip>
              ),
            },
            {
              field: "B_Barcode",
              headerName: "Barcode",
              width: 120,
            },
            {
              field: "Old_DisContinued",
              headerName: "Old",
              width: 40,
              align: "center",
              cellClassName: ({ row }) =>
                getOldCellClass(row.Old_DisContinued, row.New_DisContinued),
            },
            {
              field: "New_DisContinued",
              headerName: "New",
              width: 40,
              align: "center",
              cellClassName: ({ row }) =>
                getNewCellClass(row.Old_DisContinued, row.New_DisContinued),
            },
            {
              field: "B_Appr_DisContinued",
              headerName: "App",
              width: 70,
              align: "center",
              renderCell: (params) => {
                const { row } = params;
                if (row?.Old_DisContinued !== row?.New_DisContinued) {
                  return (
                    <div style={{ width: "100%" }}>
                      <Select
                        disabled={isEditAllowed === "Y" ? false : true}
                        value={row?.B_Appr_DisContinued}
                        onChange={(e) =>
                          handleFieldEdit(
                            params,
                            e?.target?.value,
                            "B_Appr_DisContinued"
                          )
                        }
                        fullWidth
                      >
                        {yesNoOptions.map((opt) => (
                          <MenuItem key={opt.Uid} value={opt.Uid}>
                            {opt.Uid}
                          </MenuItem>
                        ))}
                      </Select>
                    </div>
                  );
                }
                return null;
              },
            },
            {
              field: "B_NarrationName",
              headerName: "Reason",
              width: 110,
              align: "center",
            },
            {
              field: "B_LocationCSV",
              headerName: "Locations",
              minWidth: 200,
              flex:1,
              align: "center",
              renderCell: (params) => {
                const { row } = params;
                return (
                  <div style={{ width: "100%" }}>
                    <GCAutocompleteCheckboxFixSizeUid
                      // xDisabled={isEditAllowed === "Y" ? false : true}
                      xLabelText="Location"
                      xValue={row?.B_LocationCSV}
                      setValue={(updated) => {
                        // handleDetailChange("B_LocationCSV", updated);
                        handleFieldEdit(params, updated, "B_LocationCSV");
                      }}
                      options={vRdxuserLoc ?? []}
                      objName="location"
                      placeholder="Search Location"
                    />
                  </div>
                );
              },
            },
            {
              field: "Department",
              headerName: "Department",
              width: 180,
            },
            {
              field: "B_Status",
              headerName: "Reject",
              width: 60,
              align: "center",
              sortable: false,
              filterable: false,
              disableColumnMenu: true,
              renderCell: (params) => {
                const checked = Boolean(Number(params.row?.B_Status));
                return (
                  <Checkbox
                    size="small"
                    checked={checked}
                    onChange={(e) =>
                      handleFieldEdit(params, e.target.checked, "B_Status")
                    }
                  />
                );
              },
            },
            {
              field: "P_B_RejectDetail",
              headerName: "Reject Type",
              width: 120,
              renderCell: (params) => (
                <div style={{ width: "100%" }}>
                  <Select
                    value={params.row.P_B_RejectDetail || ""}
                    onChange={(e) =>
                      handleFieldEdit(
                        params,
                        e?.target?.value,
                        "P_B_RejectDetail"
                      )
                    }
                    size="small"
                    displayEmpty
                    fullWidth
                  >
                    {rejectTypeArr?.map((opt, index) => (
                      <MenuItem key={opt.UId + index} value={opt.UId}>
                        {opt.Name1}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
              ),
            },

            {
              field: "P_B_RejectNarration",
              headerName: "Reject Narration",
              width: 180,
              renderCell: (params) => {
                return (
                  <EditableRejectNarration
                    value={params.row.P_B_RejectNarration}
                    onSave={(newValue) =>
                      handleFieldEdit(params, newValue, "P_B_RejectNarration")
                    }
                    // disabled={
                    //   HeadObject?.Head?.approveStatus === "POST" ||
                    //   HeadObject?.Head?.approveStatus === "REJECT"
                    // }
                  />
                );
              },
            },
          ]}
          columnGroupingModel={columnGroupingModel}
          experimentalFeatures={{ columnGrouping: true }}
          getRowId={(row) => row.B_Srno}
          rowHeight={35}
          headerHeight={40}
          hideFooter
          getRowClassName={(params) => {
            const base =
              params.indexRelativeToCurrentPage % 2 === 0
                ? "mui-even-row"
                : "mui-odd-row";

            return Number(params.row?.B_Status) ? `${base} reject-row` : base;
          }}
          sx={{
            border: 1,
            borderColor: "primary.light",
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#0d73bb",
              color: "white",
              fontWeight: "bold",
            },
            "& .MuiDataGrid-cell": {
              padding: "4px",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              fontSize: "12px"
            },
            "& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root": {
              color: "#24292e",
            },
            "& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root.Mui-checked":
              {
                color: "#0298f5",
              },
            "& .MuiDataGrid-row.reject-row": {
              backgroundColor: "#ffe5e5 !important",
            },
          }}
          // components={{
          //   Toolbar: CustomToolbar,
          // }}
        />
      </Box>
    </>
  );
};

const EditableRejectNarration = ({ value: initialValue, onSave }) => {
  const [value, setValue] = useState(initialValue || "");

  useEffect(() => {
    setValue(initialValue || "");
  }, [initialValue]);

  const handleChange = (e) => {
    setValue(e?.target.value);
  };

  const handleBlur = () => {
    onSave(value);
  };
  const handleKeyDown = (e) => {
    if (e.key === " ") {
      e.stopPropagation();
    }
    const blocked = [
      "ArrowLeft",
      "ArrowRight",
      "ArrowUp",
      "ArrowDown",
      "Home",
      "End",
      "PageUp",
      "PageDown",
    ];
    if (blocked.includes(e.key)) e.stopPropagation();
  };

  return (
    <div style={{ width: "100%" }}>
      <TextField
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        size="small"
        autoComplete="off"
        rows={2}
        fullWidth
        sx={{ "& textarea": { fontSize: "12px" } }}
      />
    </div>
  );
};
export default ApproveModal;
